module.exports = __webpack_public_path__ + "fonts/MaterialDesignIcons.3a0b270.woff2";